import { Component, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-category-player-view-modal',
    templateUrl: './category-player-view-modal.component.html',
    styleUrls: ['./category-player-view-modal.component.scss'],
    standalone: false
})
export class CategoryPlayerViewModalComponent implements OnInit {


  categoryForm: FormGroup;
  charDetails: any
  character_id: any;
  selectedIcon: string;
  game_id: any
  iconClassArray: { className: string, iconName: string, isChecked: boolean }[] = [
    { className: 'assets/images/map-icon1.png', iconName: "First Pin", isChecked: false },
    { className: "assets/images/map-icon2.png", iconName: "Second Pin", isChecked: false },
    { className: "assets/images/map-icon3.png", iconName: "third pin", isChecked: false },
    { className: "assets/images/map-icon4.png", iconName: "fourth pin", isChecked: false },
    { className: "assets/images/map-icon5.png", iconName: "fifth pin", isChecked: false },
  ];
  @ViewChild('multiSelect') multiSelect;
  settings: any
  constructor(private formBuilder: FormBuilder, private activeModal: NgbActiveModal, private DataService: DataService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.categoryForm = this.formBuilder.group({
      category: ['', Validators.required],
      color: [null, Validators.required],
      selectedIcon: [null, Validators.required],
      details: ['', Validators.required],
      character_id: [null]
    })
    this.DataService.getCharacterBasicDetailByGameId(this.character_id, this.game_id).subscribe((data: any) => {
      if (data) {
        this.charDetails = data.characters;
        this.cdr.detectChanges();
        this.settings = {
          singleSelection: false,
          idField: 'character_id',
          textField: 'fullname',
          enableCheckAll: true,
          selectAllText: 'Select All',
          unSelectAllText: 'Unselect All',
          allowSearchFilter: false,
          limitSelection: -1,
          clearSearchFilter: false,
          maxHeight: 197,
          itemsShowLimit: 3,
          noDataAvailablePlaceholderText: 'Data Not Avaliable',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false,
        }
      }
    });
  }


  get f() {
    return this.categoryForm.controls;
  }
  handleSubmit() {
    if (this.categoryForm.valid) this.activeModal.close({ ...this.categoryForm.value })
    else {
      this.categoryForm.markAllAsTouched()
    };
  }

  closeForm() {
    this.activeModal.close(false)
  }
  selectedIconHandle(index) {
    this.iconClassArray.forEach((element) => {
      element.isChecked = false
    })
    this.iconClassArray[index].isChecked = true

    this.selectedIcon = this.iconClassArray[index].className
    this.categoryForm.get('selectedIcon').setValue(this.selectedIcon)
    this.categoryForm.updateValueAndValidity()

  }

}
